/* Korhonen header v3 — scroll state, dark-glass mega-menu, mobile full-screen menu */
(function () {
  'use strict';

  var header = document.querySelector('[data-k-header]');
  if (!header) return;

  /* ---------- Transparent over dark hero + scrolled state ---------- */
  if (document.querySelector('[data-dark-hero]')) {
    header.classList.add('k-header--transparent');
  }
  function onScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Desktop mega-menu ---------- */
  var megaWrap = header.querySelector('[data-mega-wrap]');
  var megaTrigger = header.querySelector('[data-mega-trigger]');
  var megaPanel = header.querySelector('[data-mega-panel]');
  var scrim = header.querySelector('[data-mega-scrim]');
  var closeTimer = null;

  function megaOpen() {
    if (!megaPanel) return;
    clearTimeout(closeTimer);
    megaPanel.hidden = false;
    scrim.hidden = false;
    requestAnimationFrame(function () {
      megaPanel.classList.add('is-open');
      scrim.classList.add('is-open');
    });
    if (megaTrigger) megaTrigger.setAttribute('aria-expanded', 'true');
  }
  function megaClose(immediate) {
    if (!megaPanel) return;
    megaPanel.classList.remove('is-open');
    scrim.classList.remove('is-open');
    if (megaTrigger) megaTrigger.setAttribute('aria-expanded', 'false');
    var delay = immediate ? 0 : 300;
    closeTimer = setTimeout(function () {
      megaPanel.hidden = true;
      scrim.hidden = true;
    }, delay);
  }
  /* Stable hover: keep the menu open while the pointer is over the trigger, the panel,
     OR the corridor between them — eliminates the gap flicker the per-element mouseleave caused. */
  function megaSafe(x, y) {
    var t = megaWrap.getBoundingClientRect();
    var pEl = megaPanel.querySelector('.k-mega__panel') || megaPanel;
    var p = pEl.getBoundingClientRect();
    var inTrigger = x >= t.left && x <= t.right && y >= t.top && y <= t.bottom;
    var inPanel = x >= p.left && x <= p.right && y >= p.top && y <= p.bottom;
    var loX = Math.min(t.left, p.left), hiX = Math.max(t.right, p.right);
    var inBridge = y >= t.bottom - 2 && y <= p.top + 2 && x >= loX && x <= hiX;
    return inTrigger || inPanel || inBridge;
  }
  function megaTrack(e) {
    if (!megaPanel || megaPanel.hidden) return;
    if (megaSafe(e.clientX, e.clientY)) { clearTimeout(closeTimer); closeTimer = null; }
    else if (!closeTimer) { closeTimer = setTimeout(function () { megaClose(); }, 180); }
  }

  if (megaWrap && megaPanel) {
    megaWrap.addEventListener('mouseenter', megaOpen);
    document.addEventListener('mousemove', megaTrack);
    megaTrigger.addEventListener('focus', megaOpen);
    megaTrigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); megaOpen(); var f = megaPanel.querySelector('a'); if (f) f.focus(); }
    });
    megaPanel.addEventListener('focusout', function (e) {
      if (!megaPanel.contains(e.relatedTarget) && e.relatedTarget !== megaTrigger) megaClose();
    });
    if (scrim) scrim.addEventListener('click', function () { megaClose(true); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && megaPanel && !megaPanel.hidden) { megaClose(true); megaTrigger.focus(); }
    });
  }

  /* ---------- Mobile full-screen menu ---------- */
  var mnav = document.querySelector('[data-mnav]');
  var openBtn = document.querySelector('[data-mnav-open]');
  var lastFocus = null;

  function trapFocus(container, e) {
    var focusables = container.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var visible = Array.prototype.filter.call(focusables, function (el) { return el.offsetParent !== null; });
    if (!visible.length) return;
    var first = visible[0], last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function mnavOpen() {
    if (!mnav) return;
    lastFocus = document.activeElement;
    mnav.hidden = false;
    requestAnimationFrame(function () { mnav.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    showPane('root', true);
    var c = mnav.querySelector('[data-mnav-close]');
    if (c) c.focus();
  }
  function mnavClose() {
    if (!mnav) return;
    mnav.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { mnav.hidden = true; }, 300);
    if (lastFocus) lastFocus.focus();
  }

  function showPane(name, instant) {
    var panes = mnav.querySelectorAll('.k-mnav__pane');
    panes.forEach(function (p) {
      var isTarget = p.getAttribute('data-pane') === name;
      if (isTarget) {
        p.hidden = false;
        if (!instant) {
          p.classList.add('k-mnav__pane--in-start');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { p.classList.remove('k-mnav__pane--in-start'); });
          });
        }
      } else if (!p.hidden) {
        if (instant) { p.hidden = true; }
        else {
          p.classList.add('k-mnav__pane--out');
          setTimeout(function () { p.hidden = true; p.classList.remove('k-mnav__pane--out'); }, 300);
        }
      }
    });
  }

  if (mnav && openBtn) {
    openBtn.addEventListener('click', mnavOpen);
    mnav.addEventListener('click', function (e) {
      var closeEl = e.target.closest('[data-mnav-close]');
      if (closeEl) { mnavClose(); return; }
      var go = e.target.closest('[data-pane-go]');
      if (go) { showPane(go.getAttribute('data-pane-go')); return; }
      var back = e.target.closest('[data-pane-back]');
      if (back) { showPane('root'); return; }
    });
    mnav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { mnavClose(); }
      if (e.key === 'Tab') trapFocus(mnav, e);
    });
  }
})();
